// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationGroupId } from './FermentationGroup';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationGroupOnCallId = (z.number());
export const fermentationGroupOnCall = z.object({
    id: fermentationGroupOnCallId,
    fermentation_group_id: fermentationGroupId,
    operator_id: operatorId,
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const fermentationGroupOnCallInitializer = z.object({
    id: fermentationGroupOnCallId.optional(),
    fermentation_group_id: fermentationGroupId,
    operator_id: operatorId,
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const fermentationGroupOnCallMutator = z.object({
    id: fermentationGroupOnCallId.optional(),
    fermentation_group_id: fermentationGroupId.optional(),
    operator_id: operatorId.optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationGroupOnCall.js.map